/**
 * @desc 海关要素-导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.customsInfo.exportExcel.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/customsInfo/exportExcel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
